'use client';
import { useEffect, useState } from 'react';
import { gtmProductDetail } from '@/utils/events/gtmEvents';
import { useProduct, useSelectedVariant } from '../product/product-context';

export default function GtmProduct() {
  const { productData } = useProduct();
  const { variant } = useSelectedVariant();
  const product = productData?.shopifyProduct;
  const [productDetailRan, setProductDetailRan] = useState(false);

  useEffect(() => {
    async function sendGtmProductDetail() {
      //check to see if event already ran, for now just want to run this once per PDP, not every time variant is changed
      if (window !== undefined && !productDetailRan) {
        window.dataLayer = window.dataLayer || [];
        gtmProductDetail(product, variant);
        setProductDetailRan(true);
      }
    }
    sendGtmProductDetail();
  }, [product, variant, productDetailRan]);

  return null;
}
